export const AD_BLOCK_BLACKSCREEN_SEC = 1

export function adBlockBlackDurationSec(
  spotCount: number,
  transitionDurationMs = AD_BLOCK_BLACKSCREEN_SEC * 1000,
): number {
  return Math.max(0, spotCount - 1) * transitionDurationMs / 1000
}

export function adBlockTotalDurationSec(
  spotDurationsSec: number[],
  transitionDurationMs = AD_BLOCK_BLACKSCREEN_SEC * 1000,
): number {
  return spotDurationsSec.reduce((acc, durationSec) => acc + durationSec, 0)
    + adBlockBlackDurationSec(spotDurationsSec.length, transitionDurationMs)
}
